import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import { VerificationListItem } from '@app/store/transport-layer/types/verification';

/**
 * GET 문서 추가 인증 조회
 *
 * Endpoint path and response is modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#a0af43771fae48cb93fa4e7227a25386
 */
interface Verification {
  methods: Array<{
    type: 'PASSWORD' | 'MOBILE_IDENTIFICATION' | 'D_CERT';
    passValue: string | null;
  }>;
  participantId: string;
}

export interface DocumentsVerificationsResponse {
  verifications: Array<Verification>;
}

/**
 * @param verifications 지금 리스폰스 오는 데이터 타입 (문설정통에서 participantId 제거 후 participant 추가하는게 누락됨)
 * @return participant로 participantId를 매핑시킨 문설정통 이후 스펙에 맞는 타입
 */
function convertToTransportLayerTypeVerification(
  verifications: Verification[]
): VerificationListItem[] {
  return verifications.map((verification) => ({
    participant: {
      id: verification.participantId,
      dataLabel: verification.participantId,
    },
    methods: verification.methods,
  }));
}

export function getDocumentsVerifications({
  documentId,
  workspaceId,
}: {
  documentId: string;
  workspaceId: string;
}): Promise<VerificationListItem[]> {
  return requestApi<DocumentsVerificationsResponse>({
    url: withDocument(`/workspaces/${workspaceId}/documents/${documentId}/verifications`),
    method: 'GET',
    credentials: true,
  }).then(({ data: { verifications } }) => convertToTransportLayerTypeVerification(verifications));
}
